module.exports = __webpack_public_path__ + "static/media/designerCut-01.a434b782.png";